import { Col, DatePicker, Form, Input, Row, Select } from "antd";
import React from "react";
import {
  BusinessNaturesTypeOptions,
  BusinessTypeOptions,
} from "../../Clients/Clients";
import { TypeOfAddress } from "../../../Services/LedgerService";
import ClientService from "../../../Services/ClientService";
import { dayjs } from "../../../../Utilities/dayjs";

interface IFirstStepReg {
  index: number;
  setChangeState: any;
  changeState: any;
}
const FirstStepReg = ({
  index,
  setChangeState,
  changeState,
}: IFirstStepReg) => {
  const [statesOption, setStatesOption] = React.useState<any[]>([]);

  React.useEffect(() => {
    ClientService.getStateOption(false).then((res: any) => {
      setStatesOption(res?.result);
    });
  }, [changeState]);
  return (
    <>
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        {/* <Form form={form}> */}
        <Form.Item
          label="Organization Name"
          name={[index, "organizationName"]}
          rules={[
            {
              required: true,
              min: 6,
              message: " Organization Name is required",
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.]*$/,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Business Type" name={[index, "businessType"]}>
          <Select
            style={{ width: "100%" }}
            options={BusinessTypeOptions}
            placeholder="Select"
          />
        </Form.Item>
        <Form.Item label="Business Natures" name={[index, "businessNature"]}>
          <Select
            options={BusinessNaturesTypeOptions}
            placeholder="Select"
            mode="multiple"
          />
        </Form.Item>
        <Form.Item label="Business Start Date" name={[index, "businessStart"]}>
          <DatePicker
            style={{ width: "100%" }}
            format={"DD-MM-YYYY"}
            disabledDate={(current) =>
              current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
            }
          />
        </Form.Item>
        <Form.Item label="Business Address (Type)" name={[index, "type"]}>
          <Select
            placeholder="Type"
            options={[
              {
                label: "Registered Address",
                value: TypeOfAddress.RegisteredAddress,
              },
              {
                label: "Business Address",
                value: TypeOfAddress.BusinessAddress,
              },
              {
                label: "Branch Address",
                value: TypeOfAddress.BranchAddress,
              },
              {
                label: "Unit Address",
                value: TypeOfAddress.UnitAddress,
              },
              {
                label: "Godown Address",
                value: TypeOfAddress.GodownAddress,
              },
            ]}
          />
        </Form.Item>
        <Form.Item label="Address" name={[index, "building"]}>
          <Input placeholder="Building name or Address line 1" />
        </Form.Item>
        <Form.Item name={[index, "street"]}>
          <Input placeholder="Street/building/village name" />
        </Form.Item>
        <Form.Item name={[index, "landmark"]}>
          <Input placeholder="City/town name or Address line 3" />
        </Form.Item>
        <Form.Item name={[index, "city"]}>
          <Input placeholder="City" />
        </Form.Item>
        <Row gutter={10}>
          <Col span={12}>
            <Form.Item name={[index, "district"]}>
              <Input placeholder="District" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={[index, "state"]}
              rules={[
                {
                  required: true,
                  message: "Please select the State",
                },
              ]}
            >
              <Select
                placeholder="Select..."
                options={statesOption.map((x: any) => ({
                  value: x.id,
                  label: x.name,
                }))}
                onChange={(val: any) => setChangeState(val)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={10}>
          <Col span={12}>
            <Form.Item name={[index, "country"]}>
              <Input placeholder="Country" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={[index, "pincode"]}
              rules={[
                {
                  required: true,
                  message: "Please enter the pincode",
                },
                {
                  pattern: /^[1-9][0-9]{5}$/,
                  message: "Pincode must be a 6-digit number",
                },
              ]}
            >
              <Input placeholder="Pincode" type="number" />
            </Form.Item>
          </Col>
        </Row>
        {/* </Form> */}
      </div>
    </>
  );
};

export default FirstStepReg;
